// Scene.jsx
import React from "react";
import SceneLighting from "./components/SceneLighting.jsx";
import SceneEnvironment from "./components/SceneEnvironment.jsx";
import Room from "./Room";

export default function Scene() {

  return (
    <>
      <SceneLighting />
      <SceneEnvironment />
      <Room />
    </>
  );
}
